import { computed } from "vue";

export default {
  data() {
    return {
      tenantId: this.realm,
      apiUrl: this.digitalTwinModelSummaryConfig.api,
    };
  },
  created() {},
  provide() {
    return {
      modelDT: computed(() => this.modelDT),
    };
  },
  methods: {
    async updateModel() {
      try {
        await this.saveModel();
        this.routeTo(`/dts`);
      } catch (error) {
        console.error(error);
      }
    },
    async saveModel() {
      if (this.modelDT) {
        try {
          const sessionStorageModelObject = this.getModelToSessionStorage();
          sessionStorageModelObject.modelGraph = this.modelDT.modelGraph;
          const response = await this.axios.post(
            this.apiUrl + "/" + this.tenantId + "/models",
            sessionStorageModelObject,
            this.opts,
          );

          if (response?.data) {
            this.saveModelToSessionStorage({
              ...sessionStorageModelObject,
              ...response.data,
            });

            this.isChangedModel = false;

            this.snackbarEvent(true, this.$t("strings.save-model-success"));

            await new Promise((resolve) => setTimeout(resolve, 1500));
          }
        } catch (error) {
          this.setError(error, false, undefined, true);
          throw error;
        }
      }
    },
    getModelToSessionStorage() {
      return JSON.parse(sessionStorage.getItem("digital-twin-model"));
    },
    saveModelToSessionStorage(data) {
      sessionStorage.setItem("digital-twin-model", JSON.stringify(data));
      this.modelDT = data;
    },

    async deploy() {
      if (this.modelDT) {
        try {
          this.loaderPublishModel = true;
          const response = await this.axios.post(
            this.apiUrl +
              "/" +
              this.tenantId +
              "/models/deploy/" +
              this.modelDT.modelId,
            null,
            this.opts,
          );

          if (response?.data) {
            this.publishModel = true;
            this.snackbarEvent(true, this.$t("strings.publish-model-success"));

            await new Promise((resolve) => setTimeout(resolve, 1500));
          }
        } catch (error) {
          this.setError(error, false);
          throw error;
        } finally {
          this.loaderPublishModel = false;
        }
      }
    },
    async undeploy() {
      if (this.modelDT) {
        try {
          this.loaderPublishModel = true;
          const response = await this.axios.delete(
            this.apiUrl +
              "/" +
              this.tenantId +
              "/models/deploy/" +
              this.modelDT.modelId,
            this.opts,
          );

          if (response?.data) {
            this.publishModel = false;
            this.snackbarEvent(
              true,
              this.$t("strings.remove-publish-model-success"),
            );

            await new Promise((resolve) => setTimeout(resolve, 1500));
          }
        } catch (error) {
          this.setError(error, false);
          throw error;
        } finally {
          this.loaderPublishModel = false;
        }
      }
    },

    snackbarEvent(value, text) {
      this.snackbar = value;
      this.snackbarText = text;
    },
    //Abort the model creation
    abortModel() {
      sessionStorage.removeItem("digital-twin-model");
      this.routeTo(`/dts`);
    },
    //Goes to a new path
    routeTo(newPath) {
      this.$router.push({
        path: newPath,
      });
    },
  },
};
